const voices = [
  {
    id: 'voice-1',
    quote:
      '最难得的是他们把信息来源一条条列出来，我按图索骥去查监管公告，居然真的能对上。这在同类站点里很少见。',
    name: '周毓',
    role: '跨境合规顾问',
  },
  {
    id: 'voice-2',
    quote:
      '我常把这里的稿件当作研究素材。它的时间线整理得很干净，比零散转载的消息更容易复用到案例分析里。',
    name: '藤井直',
    role: '大学讲师 · 比较政治',
  },
  {
    id: 'voice-3',
    quote:
      '每次有新进展都会在原文顶部标更新日期，读起来踏实。不用怀疑自己看的是不是旧版本。',
    name: '陈屿',
    role: '长期读者',
  },
];

export default function Testimonials() {
  return (
    <section aria-labelledby="home-voices" className="rounded-lg bg-background-200/60 p-6 md:p-10">
      <div className="mb-6 max-w-2xl md:mb-8">
        <p className="mb-2 font-label text-xs uppercase tracking-[0.28em] text-primary-600">
          Readers
        </p>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          读者怎么说
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          来自研究人员、从业者与长期读者的反馈，也是我们调整选题与写作方式的重要参考。
        </p>
      </div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {voices.map((voice) => (
          <figure
            key={voice.id}
            className="flex h-full flex-col rounded-lg border border-background-300/70 bg-background-50 p-5"
          >
            <span className="flex h-8 w-8 items-center justify-center font-heading text-2xl leading-none text-accent-500">
              <i className="ri-double-quotes-l" />
            </span>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {voice.quote}
            </blockquote>
            <figcaption className="mt-4 border-t border-background-200 pt-3">
              <span className="block font-heading text-sm font-bold text-foreground-950">
                {voice.name}
              </span>
              <span className="mt-0.5 block font-label text-xs text-foreground-500">
                {voice.role}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}